module.exports = __webpack_public_path__ + "img/qps.cbdee7f1.png";